import type { RelationshipStatus } from "@kontextwerk/control-web-client"
import type {
  IdentityAdministrationApi,
  KehrblattMembershipChange,
} from "../../../../../../../../../../../api/kehrblatt/identity-administration"
import {
  runConfirmedChange,
  type ConfirmedChangeOutcome,
} from "../../../../../_shared/_logic/confirmed-change"
import type { MemberRow } from "../_shared/_logic/table"

export type MembershipAccessCommand = Readonly<{
  api: IdentityAdministrationApi
  member: MemberRow
  status: RelationshipStatus
}>

/** `failed` without a request when the row lacks the membership facts the write requires. */
export type MembershipAccessResult = ConfirmedChangeOutcome<KehrblattMembershipChange>

/**
 * Suspends or reactivates one membership with its current role and the revision the row was
 * built from. A stale revision becomes `conflict`; the role is never changed by this command.
 */
export const changeMembershipAccess = async ({
  api,
  member,
  status,
}: MembershipAccessCommand): Promise<MembershipAccessResult> => {
  const roleId = member.roleId
  const revision = member.membershipRevision

  if (!roleId || revision === null) return { status: "failed" }

  const suspend = status === "suspended"

  return runConfirmedChange(
    {
      title: suspend ? "Benutzer sperren" : "Benutzer entsperren",
      description: suspend
        ? `${member.name} verliert sofort den Zugriff auf diese Organisation. Bitte bestätigen Sie die Sperre mit Ihrem aktuellen Passwort.`
        : `${member.name} erhält wieder Zugriff mit der bisherigen Rolle. Bitte bestätigen Sie die Aktion mit Ihrem aktuellen Passwort.`,
      actionLabel: suspend ? "Sperren" : "Entsperren",
    },
    () =>
      api.changeMembership(member.membershipId, {
        role_id: roleId,
        status,
        expected_revision: revision,
      }),
  )
}
